// 9fbef606107a605d69c0edbcd8029e5d
import logger from '@tcp/core/src/utils/loggerInstance';
import {
  extractAttributeValue,
  extractPrioritizedBadge,
  getPLPProductAttributes,
  extractZoneOneBadges,
  extractZoneSixBadges,
} from '@tcp/core/src/utils/badge.util';

const FILE_NAME = 'plpTileBadgesHelper';

function convertQuotes(str) {
  if (str && !(str.includes('{') || str.includes("'"))) return str;

  // Remove outer curly braces to process as a key-value pair string
  const keyValuePairs = str.slice(1, -1).split(',');

  // Process each key-value pair
  const processedPairs = keyValuePairs.map((pair) => {
    const [key, value] = pair.split(':');

    // Use a regular expression to match single quotes at the beginning or end
    const processedKey = key.trim().replace(/^'/, '"').replace(/'$/, '"');
    const processedValue = value.trim().replace(/^'/, '"').replace(/'$/, '"');

    return `${processedKey}:${processedValue}`;
  });

  // Reconstruct the object string with double quotes
  return `{${processedPairs.join(',')}}`;
}

const topRatedCategoryCheck = (tileData, categoryId) => {
  const topRatedCategories = extractAttributeValue(tileData, 'topRatedCategories');
  try {
    const topRatedOb = topRatedCategories && JSON.parse(convertQuotes(topRatedCategories));
    if (topRatedOb && topRatedOb[Number(categoryId)]) {
      return true;
    }
  } catch (e) {
    logger.error({
      error: e,
      extraData: {
        title: 'An error occurred while parsing the top rated badge categories response',
        componentName: FILE_NAME,
        methodName: 'topRatedCategoryCheck',
        tileData,
        categoryId,
      },
    });
    return false;
  }
  return false;
};
const bestSellerCategoryCheck = (tileData, categoryId) => {
  const bestSellerCategories = extractAttributeValue(tileData, 'FeaturedCategories');
  try {
    const bestSellerObj = bestSellerCategories && JSON.parse(convertQuotes(bestSellerCategories));
    if (bestSellerObj && bestSellerObj[Number(categoryId)]) {
      return true;
    }
  } catch (e) {
    logger.error({
      error: e,
      extraData: {
        title: 'An error occurred while parsing the best seller badge categories response',
        componentName: FILE_NAME,
        methodName: 'bestSellerCategoryCheck',
        tileData,
        categoryId,
      },
    });
    return false;
  }
  return false;
};

const mostFavoritedCategoryCheck = (tileData, categoryId) => {
  const mostFavoritedCategories = extractAttributeValue(tileData, 'mostFavoritedCategories');
  try {
    const mostFavoritedObj =
      mostFavoritedCategories && JSON.parse(convertQuotes(mostFavoritedCategories));
    if (mostFavoritedObj && mostFavoritedObj[Number(categoryId)]) {
      return true;
    }
  } catch (e) {
    logger.error({
      error: e,
      extraData: {
        title: 'An error occurred while parsing the most favorited badge categories response',
        componentName: FILE_NAME,
        methodName: 'mostFavoritedCategoryCheck',
        tileData,
        categoryId,
      },
    });
    return false;
  }
  return false;
};

const getPlpTileBadges = ({
  tileData,
  categoryName,
  bestSellerBadgeLabel,
  topRatedBadgeLabel,
  mostFavoritedBadgeLabel,
  isBundleProduct,
}) => {
  const productAttr = getPLPProductAttributes();
  const badges = extractPrioritizedBadge(tileData, productAttr, categoryName, '');
  const zoneOneBadges = extractZoneOneBadges(tileData, productAttr, categoryName);
  const zoneSixBadges = extractZoneSixBadges(tileData, productAttr, categoryName, isBundleProduct);

  const { categoryData = '|' } = tileData;
  const [categoryId] = categoryData.split('|');
  const topRatedIdMatches = topRatedCategoryCheck(tileData, categoryId);
  const bestSellerIdMatches = bestSellerCategoryCheck(tileData, categoryId);
  const mostFavoritedIdMatches = mostFavoritedCategoryCheck(tileData, categoryId);
  const {
    defaultBadge = '',
    topRatedBadge = false,
    isBestSeller = false,
    mostFavoritedBadge = false,
    merchantTag = '',
    extendedSize = '',
  } = badges;

  return {
    topBadge: defaultBadge,
    topRatedBadge: `${topRatedBadge && topRatedIdMatches ? topRatedBadgeLabel : ''}`,
    bestSellerBadge: `${isBestSeller && bestSellerIdMatches ? bestSellerBadgeLabel : ''}`,
    mostFavoritedBadge: `${
      mostFavoritedBadge && mostFavoritedIdMatches ? mostFavoritedBadgeLabel : ''
    }`,
    merchantTag,
    extendedSizes: extendedSize,
    zoneOneBadges,
    zoneSixBadges,
  };
};

export default getPlpTileBadges;
